package com.evoapps.evoshift.domain.provider

/**
 * The platform's "Continue with Google" sheet: Credential Manager on Android, GoogleSignIn-iOS on
 * iOS, a Firebase popup on the web, the system browser on the Mac (composeApp,
 * `GoogleSignInClient.*.kt`, `auth/DesktopSignInClients.kt`).
 */
interface GoogleSignInClient {
    /** Shows the account picker; null when the person backs out. */
    suspend fun signIn(): GoogleCredential?
}

/**
 * What Firebase Auth needs to sign in with Google: an ID token, an access token, or both. With
 * [signedIn] the platform's own flow has already signed Firebase in (the Mac app, whose Firebase
 * SDK cannot take a Google credential) and the tokens are not used.
 */
data class GoogleCredential(val idToken: String?, val accessToken: String? = null, val signedIn: Boolean = false) {
    companion object {
        /** The platform's flow has signed in already (the Mac app). */
        val SignedIn = GoogleCredential(idToken = null, signedIn = true)
    }
}
